/**
 * Logikk for Organizational Health Insight Engine
 * Kobler sammen alle indekser for å identifisere systemiske rotårsaker.
 */

export const INSIGHT_PATTERNS = [
  {
    id: 'culture-risk',
    condition: (m) => m.orgHealth < 50 && m.culture < 50,
    title: 'Culture-driven Organizational Risk',
    type: 'Systemic',
    severity: 'Critical',
    hypothesis: 'Den lave organisatoriske helsen skyldes dype kulturelle brister fremfor enkelthendelser eller ressurstilgang.',
    impact: 'Høy risiko for talentflukt og svekket omdømme over tid.'
  },
  {
    id: 'leadership-capacity',
    condition: (m) => m.leadership < 50 && m.stress > 70,
    title: 'Leadership Capacity Risk',
    type: 'Leadership',
    severity: 'High',
    hypothesis: 'Lederleddet er overbelastet eller mangler kompetanse til å skjerme ansatte, noe som skaper en negativ stress-spiral.',
    impact: 'Økende sykefravær og tap av operativ kraft.'
  },
  {
    id: 'relationship-breakdown',
    condition: (m) => m.conflict > 65 && m.safety < 50,
    title: 'Relationship System Breakdown',
    type: 'Relational',
    severity: 'High',
    hypothesis: 'Mellommenneskelige gnisninger har blitt systemiske fordi det mangler en trygg arena for å løse uenighet.',
    impact: 'Silo-mentalitet og aktiv motarbeidelse i team.'
  },
  {
    id: 'comm-weakness',
    condition: (m) => m.safety < 45 && m.we < 50,
    title: 'Communication Climate Weakness',
    type: 'Communication',
    severity: 'Medium',
    hypothesis: 'Informasjonsflyten er blokkert av en taushetskultur, noe som gjør at feil ikke fanges opp tidlig.',
    impact: 'Lav innovasjonstakt og gjentakende feilproduksjon.'
  }
];

export const getStrategicPriorities = (patterns) => {
  const priorities = [];
  if (patterns.some(p => p.id === 'culture-risk')) {
    priorities.push({ title: 'Kultur-revisjon', desc: 'Gjennomgang av kjerneverdier og adferdsnormer med toppledelsen.', focus: 'Strategisk' });
  }
  if (patterns.some(p => p.id === 'leadership-capacity')) {
    priorities.push({ title: 'Lederstøtte-program', desc: 'Operativ avlastning og coaching for operative ledere.', focus: 'Operativ' });
  }
  if (patterns.some(p => p.id === 'relationship-breakdown')) {
    priorities.push({ title: 'Konflikthåndterings-system', desc: 'Implementering av formelle og uformelle meklingsrutiner.', focus: 'Kulturell' });
  }
  return priorities;
};

export const generate90DayPlan = (patterns) => {
  return [
    { day: 'Dag 1-30', task: 'Stabilisering & Diagnose', desc: 'Dybdeintervjuer med nøkkelpersoner for å validere AI-hypoteser.' },
    { day: 'Dag 31-60', task: 'Intervensjonsfase', desc: 'Gjennomføring av prioriterte workshops og ledercoaching.' },
    { day: 'Dag 61-90', task: 'Evaluering & Re-måling', desc: 'Ny pulsmåling for å verifisere effekt av tiltak.' }
  ];
};

export const mockEngineInput = {
  we: 52,
  orgHealth: 48,
  culture: 45,
  leadership: 42,
  conflict: 68,
  stress: 75,
  safety: 38
};